import { Box, Button, FormLabel, MenuItem, Select, TextField, Typography } from "@mui/material"
import { Translate } from "react-i18nify"
import { DEVICE_TYPE } from "../../pages/Production/Production"
import { memo, useState, useEffect } from "react"
import { translate } from "react-i18nify";
import { defaultMetadata } from "./TestCasesContainer"

export const TestMetaData = ({ deviceType, puid, setPuid, mac, setMac, swfw, selectedSwFw, setSelectedSwFw, checkMetadataErrors, equipment}) => {

    const [eqArray, setEqArray] = useState(equipment?.current)

    const [macInputErros, setMacInputErros] = useState({ 
        errorText: "mac needs to match patteren XXXXXXXXXX", 
        active: false 
    })
    const [puidInputErros, setPuidInputErros ] = useState({ 
        errorText: deviceType === DEVICE_TYPE.HOT.code ? "puid needs to match patteren 1A2b3C4d5E6f7A8b" : "puid needs to match patteren 0032001A3038510232323935" , //new RegExp("^[0-9]{3}[a-zA-Z0-9][0-9]{3}[a-zA-Z0-9]{17}$");
        active: false 
    },)
    const [swFwErrors, setSwFwErrors ] = useState({
        errorText: "SwFwNotSelected", 
        sw: true,
        fw: true, 
    },)

    const checkInput = (val, valType) => {
        if(valType === TRACEVALUES.PUID){
            const patterenResult = deviceType === DEVICE_TYPE.HOT.code ? !TRACEPATTERNS.UDSN_HOT.test(val) : !TRACEPATTERNS.UDSN_PRO.test(val)
            updateErrors(patterenResult, setPuidInputErros)
            checkMetadataErrors(patterenResult, macInputErros.active, swFwErrors)
        }
        if(valType === TRACEVALUES.MAC){
            const patterenResult = !TRACEPATTERNS.MACWO.test(val)
            updateErrors(patterenResult, setMacInputErros)
            checkMetadataErrors(puidInputErros.active, patterenResult, swFwErrors)
        }
    }

    const updateErrors = (val, setError) => {
        setError((prev) => {
            return {
                ...prev, 
                active: val
            }
        })
    }

    const addEquipment = () => {
        const copy = eqArray
        copy.push({type: TESTMETADATATYPES.EQUIPMENT, typeId: "", id: "", required: false})
        setEqArray([...copy])
    }

    //This timeout is made to only change text field values after 'textChangeTimeOut' amount of time.
    //If the timeout was not present every keyboard press would result in slowing down the process
    //So for the text to update in the state, you have to not type for 1 second. 
    const textChangeTimeOut = 1000
    let pressTimeout = setTimeout(() => {
    },textChangeTimeOut)

    const onChangeValue = (e, valType) => {
        const newValue = e.target.value
        try{
            clearTimeout(pressTimeout)
        }catch(e){

        }
        if(valType === TRACEVALUES.MAC || valType === TRACEVALUES.PUID){
                checkInput(newValue, valType)
                if(valType === TRACEVALUES.PUID)
                    setPuid(prev => {
                        return {
                            ...prev,
                            value: newValue
                        }
                    })
                if(valType === TRACEVALUES.MAC)
                    setMac(prev => {
                        return {
                            ...prev,
                            value: newValue
                        }
                    })
        }else{
            setSelectedSwFw((prev) => {
                return {
                    ...prev,
                    [valType]: newValue
                }
            })
            const newValueIsNull = newValue.value === ""
            let currentSwfwErrors = swFwErrors;
            currentSwfwErrors[valType] = newValueIsNull
            setSwFwErrors(currentSwfwErrors)
            checkMetadataErrors(puidInputErros.active, macInputErros.active, currentSwfwErrors)
        }
    }

    useEffect(() => { 
        try{
            checkInput(puid.value, TRACEVALUES.PUID)
            checkInput(mac.value, TRACEVALUES.MAC)
        }catch(e){
            console.error(e)
        }
    },[])

    return(
        <Box id="MetadataContainer" sx={{ display: "flex", flexDirection: "row", mb:3, mt:5, width:{ md:1000 }, maxWidth: 1000 }} >

            <Box id="TraceValueContainer" sx={{ display: "flex", flexDirection: "column", width: {md: "40%",}, maxWidth: 1000  }} >
                <Box id="macPuidContainer" sx={{ display: "flex", flexDirection: "column", width:"100%" }} >
                    <Box id="puid" sx={{ flexGrow: 1, }} >
                        <FormLabel>
                            <Typography> <Translate value={"ProcessorSerialNumber"} /></Typography>
                        </FormLabel>                 
                        <TextField
                            value={puid?.value}
                            required
                            error={puidInputErros.active}
                            helperText={puidInputErros.active ? puidInputErros.errorText : ""}
                            onChange={(e) => onChangeValue(e, TRACEVALUES.PUID)}
                            inputProps={{
                                pattern: deviceType === DEVICE_TYPE.HOT.code ? "^[a-fA-F0-9]{16}$" : "^[0-9]{3}[a-zA-Z0-9][0-9]{3}[a-zA-Z0-9]{17}$",
                            }}
                            sx={{
                                width:"60%"
                            }}
                        >
                        </TextField>
                    </Box>
                    {
                        deviceType === DEVICE_TYPE.HOT.code ?
                            <Box id="mac" sx={{ flexGrow: 1 }} >
                                <FormLabel>
                                    <Typography> <Translate value={"MacAddress"} /></Typography>
                                </FormLabel>                 
                                <TextField
                                    value={mac?.value}
                                    required
                                    error={macInputErros.active}
                                    helperText={macInputErros.active ? macInputErros.errorText : ""}
                                    onChange={(e) => onChangeValue(e, TRACEVALUES.MAC)}
                                    inputProps={{
                                        pattern: "^([0-9A-Fa-f]{12})$",
                                    }}
                                    sx={{
                                        width:"60%"
                                    }}
                                >
                                </TextField>
                            </Box>
                        :
                            <></>
                    }
                </Box>
                <Box id="swFwContainer" sx={{ display: "flex", flexDirection: "column" }} >
                    <Box id="sw" sx={{ flexGrow: 1 }} >
                        <FormLabel>
                            <Typography> <Translate value={"SoftwareVersion"} /></Typography>
                        </FormLabel>                 

                        <Select
                        sx={{ width: "200px" }}
                        required
                        id="software"
                        displayEmpty
                        value={selectedSwFw?.sw}
                        onChange={(e) => onChangeValue(e, TRACEVALUES.SW)}
                        >
                        <MenuItem value={defaultMetadata}>
                            <Translate value="Select" /> software
                        </MenuItem>
                        {swfw?.sw?.map((l) => {
                            return (
                            <MenuItem key={l.id} value={l}>
                                {l.value}
                            </MenuItem>
                            );
                        })}
                        </Select>
                    </Box>
                    <Box id="fw" sx={{ flexGrow: 1 }} >
                        <FormLabel>
                            <Typography> <Translate value={"FirmwareVersion"} /></Typography>
                        </FormLabel>                 
                        <Select
                        sx={{ width: "200px" }}
                        required
                        id="firmware"
                        displayEmpty
                        value={selectedSwFw?.fw}
                        onChange={(e) => onChangeValue(e, TRACEVALUES.FW)}
                        >
                        <MenuItem value={defaultMetadata}>
                            <Translate value="Select" /> firmware
                        </MenuItem>
                        {swfw?.fw?.map((l) => {
                            return (
                            <MenuItem key={l.id} value={l}>
                                {l.value}
                            </MenuItem>
                            );
                        })}
                        </Select>
                    </Box>
                </Box>
            </Box>
            <Box id="EquipmentContainer" sx={{ width:"50%", borderLeft:2, borderColor:"#b9bbbe", px:5 }} >
                <Box sx={{ mb:1 }} >
                    <FormLabel>
                        <Typography>
                            <Translate value="EquipmentUsed" />
                        </Typography>
                    </FormLabel>
                </Box>
                <Box sx={{ mb:1 }}>
                    <Button id="AddEquipment" onClick={addEquipment} variant="contained">
                        <Translate value="AddEquipment" />
                    </Button>
                </Box>
                <Box>
                    {
                        eqArray?.map((eq,i) => {
                            return(
                                <Box id={"EqRow" + i} sx={{  display:"flex", flexDirection:"row" }} >
                                    {/* The equipment is only required if it matches the equipment meta data on protocol */}
                                    <EquipmentRow refEq={eq} required={eq.required} /> 
                                </Box>
                            )
                        })
                    }
                </Box>
            </Box>
        </Box>
    )
}

const EquipmentRow = memo(function EquipmentRow({refEq, required}){

    const [eqTypeId, setEqTypeId] = useState(refEq.typeId)
    const [eqId, setEqId] = useState(refEq.id)

    const onChangeValue = (event, valueType) => {
        const newValue = event.target.value
        if(valueType === EQUIPMENTDATA.EQTYPE){
            setEqTypeId(newValue)
            refEq.typeId = newValue
        }else{
            setEqId(newValue)
            refEq.id = newValue
        }
    }

    return(
        <Box sx={{ display:"flex", flexDirection:"row", mb:2, height: 110 }} >
            <Box sx={{ flexGrow:1, maxWidth: 190 }} >
                <FormLabel>
                    <Typography> <Translate value={"EquipmentTypeId"} /></Typography>
                </FormLabel>                 
                <TextField
                    value={eqTypeId}
                    required={required}
                    onChange={(e) => onChangeValue(e, EQUIPMENTDATA.EQTYPE)}
                    error={required && eqTypeId === ""}
                    FormHelperTextProps={{sx: {width: "90%"}}}
                    helperText={required && eqTypeId === "" ? translate("EquipmentTypeIsRequired") : ""}
                >
                </TextField>
            </Box>
            <Box sx={{ flexGrow:2, px:2}} >
                <FormLabel>
                    <Typography> <Translate value={"EquipmentId"} /></Typography>
                </FormLabel>                 
                <TextField
                    value={eqId}
                    required={required}                                     
                    onChange={(e) => onChangeValue(e, EQUIPMENTDATA.EQID)}
                    error={required && eqId === ""}
                    helperText={required && eqId === "" ? translate("EquipmentIdIsRequired") : ""}
                >
                </TextField>
            </Box>
        </Box>
    )
})

export const TRACEPATTERNS = {
    UDSN_HOT: new RegExp("^[a-fA-F0-9]{16}$"),
    UDSN_PRO: new RegExp("^[0-9]{3}[a-zA-Z0-9][0-9]{3}[a-zA-Z0-9]{17}$"),
    MACW:  new RegExp("^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$"),
    MACWO: new RegExp("^([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$")
}

export const EQUIPMENTPATTERENS = {
    TYPE: new RegExp("^EQ\\s.+$"),
}

export const METADATANAMES= {
    SN: "Serial Number",
    PUID: "Uid - processor",
    MAC: "MAC_Address",
    SW: "Software_Version",
    FW: "Firmware_Version",
    HOT_SW: "Hot_Software_Version",
    HOT_FW: "Hot_Firmware_Version"
}

export const TRACEVALUES = {
    SW: "sw",
    FW: "fw",
    PUID: "puid",
    MAC: "mac",
}

const EQUIPMENTDATA = {
    EQTYPE: "type",
    EQID: "id"
}

export const TESTMETADATATYPES = {
    EQUIPMENT: "Equipment"
}

export default memo(TestMetaData)